import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    mixins: [emCommonUtilMixin],
    computed: {
        $_configCode() {
            return null;
        },

        selectIds() {
            return this.checkedIdList.join(",")
        },
        checkedIdList() {
            if (this.$store.state.queryViewStore.checkChangeFlag) {
                //
            }
            let tl = this.$store.state.queryViewStore.checkedIdList[this.$_configCode];
            return tl ? tl : [];
        },
        $_checked() {
            return !this.$_notChecked;
        },
        $_checkedOne() {
            return this.checkedIdList.length === 1;
        },
        $_notChecked() {
            return this.checkedIdList.length === 0;
        },
        $_notCheckedOne() {
            return !this.$_checkedOne;
        },
        tableRows() {
            if (this.$store.state.queryViewStore.checkChangeFlag) {
                //
            }
            let tl = this.$store.state.queryViewStore.currentRows[this.$_configCode];
            return tl ? tl : [];
        },
        checkedRows() {
            return this.tableRows.filter(f => this.checkedIdList.includes(f.id));
        },
        checkedRow() {
            return this.$_checkedOne ? this.checkedRows[0] : null;
        },

    },
}
